import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { OrderCheckIn } from "@/components/OrderCheckIn";
import { useOrderOperations } from "@/hooks/useOrdersManagement/orderOperations";

export default function OrderCheckInPage() {
  const navigate = useNavigate();
  const { handleOrderCheckIn } = useOrderOperations();

  return (
    <>
      <Helmet>
        <title>New Order Check-In | Supplier Delivery</title>
        <meta name="description" content="Create a new supplier delivery order and upload invoices, goods photos, and related documents." />
        <link rel="canonical" href="/checkin" />
      </Helmet>
      <OrderCheckIn
        onBack={() => navigate(-1)}
        onSubmit={async (data) => {
          await handleOrderCheckIn(data);
          // After creation, go to orders list
          navigate("/orders");
        }}
      />
    </>
  );
}
